import React from 'react';
export function TopBanner() {
  return <section className="relative w-full bg-cream overflow-hidden" data-id="element-364">
      <div className="relative w-full" data-id="element-365">
        <img src="https://cdn.magicpatterns.com/uploads/acizNBbjCTkeT2kG8KNEHe/Imagen_Hero_._Anti_desinflamacion.png" alt="Mujer sintiéndose ligera y en paz" className="w-full h-auto object-contain" data-id="element-366" />
        <div className="absolute bottom-0 left-0 right-0 h-24 md:h-32 bg-gradient-to-b from-transparent to-cream pointer-events-none" data-id="element-367"></div>
      </div>
    </section>;
}